import { render, staticRenderFns } from "./chart-brief.vue?vue&type=template&id=a44f016a&"
import script from "./chart-brief.vue?vue&type=script&lang=ts&"
export * from "./chart-brief.vue?vue&type=script&lang=ts&"
import style0 from "./chart-brief.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports